// لوحة حسابات "البوكسات" (الحسابات الجديدة اللي ينشئها المدير - مثل تيهان):
// نفس لوحة الموظفات (KarinaDashboard) باسم الموظفة الظاهر، وبوكساتها حسب
// الصلاحيات الممنوحة من واجهة "صلاحية المستخدمين" بالترتيب المعتمد.
//   /workspace            ← الموظفة نفسها
//   /workspace/:accountId ← المدير يفتح لوحة أي موظفة
import React, { useEffect, useState } from "react";
import { Navigate, useParams } from "react-router-dom";
import { Container, Typography, CircularProgress } from "@mui/material";
import KarinaDashboard from "./KarinaDashboard";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { getCurrentProfile, getGrantedBoxes, isBoxAccount } from "./utils/userProfile";

const StaffWorkspace = () => {
  const { accountId } = useParams();
  const self = getCurrentProfile();
  const targetId = accountId || self.username;

  const [profile, setProfile] = useState(
    !accountId && isBoxAccount()
      ? { displayName: self.displayName, permissions: self.permissions }
      : null
  );
  const [error, setError] = useState("");

  useEffect(() => {
    if (!targetId) return;
    let alive = true;
    apiFetch(`${API_BASE}/staff/${encodeURIComponent(targetId)}/profile`)
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || "تعذر تحميل اللوحة");
        if (alive) setProfile({ displayName: data.displayName, permissions: data.permissions });
      })
      .catch((err) => alive && setError(err.message));
    return () => {
      alive = false;
    };
  }, [targetId]);

  // حساب قديم (إله لوحته الخاصة) فتح /workspace بالغلط
  if (!accountId && !isBoxAccount()) return <Navigate to="/" replace />;

  if (error && !profile) {
    return (
      <Container sx={{ mt: 4 }} dir="rtl">
        <Typography color="error">❌ {error}</Typography>
      </Container>
    );
  }

  if (!profile) {
    return (
      <Container sx={{ mt: 6, textAlign: "center" }}>
        <CircularProgress />
      </Container>
    );
  }

  return (
    <KarinaDashboard
      key={targetId}
      employeeName={profile.displayName}
      boxes={getGrantedBoxes(profile.permissions)}
    />
  );
};

export default StaffWorkspace;
